/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Shortcuts_TitleInputs */

const en_fc_tut_shortcuts_title = /** @type {(inputs: Fc_Tut_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essential shortcuts`)
};

/**
* | output |
* | --- |
* | "Essential shortcuts" |
*
* @param {Fc_Tut_Shortcuts_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_shortcuts_title = /** @type {((inputs?: Fc_Tut_Shortcuts_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Shortcuts_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_shortcuts_title(inputs)
});
export { fc_tut_shortcuts_title as "fc.tut.shortcuts.title" }